<template>
  <div class="btn-group" role="group">
    <button
      v-for="button in buttons"
      v-if="!button.hide"
      class="btn btn-sm"
      :class="getButtonClasses(button)"
      @click="setExpectedAnswerValueLocal(button.answer)"
      type="button"
    >
      {{ capitalizeFirstLetter(button.answer) }}
    </button>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { expectedAnswerType } from "@/entities/questionaire/answers/ExpectedAnswerType";

@Component
export default class AppButtonToggle extends Vue {
  @Prop()
  questionId!: number;

  @Prop()
  readonly hideIgnore!: boolean | null;
  hideIgnoreLocal: boolean = this.hideIgnore || false;

  @Prop()
  readonly expectedAnswer!: expectedAnswerType;
  localExpectedAnswer: expectedAnswerType =
    this.expectedAnswer || expectedAnswerType.none;

  @Watch("expectedAnswer")
  onExpectedAnswerChanged(val: expectedAnswerType) {
    this.localExpectedAnswer = val;
  }

  setExpectedAnswerValueLocal(val: expectedAnswerType) {
    this.localExpectedAnswer =
      this.localExpectedAnswer === val ? expectedAnswerType.none : val;
    this.$emit("input", this.localExpectedAnswer);
  }

  buttons = [
    {
      answer: expectedAnswerType.yes,
      type: "success"
    },
    {
      answer: expectedAnswerType.neutral,
      type: "warning",
      hide: this.hideIgnoreLocal
    },
    {
      answer: expectedAnswerType.no,
      type: "danger"
    }
  ];

  getButtonClasses(obj: { answer: expectedAnswerType; type: string }) {
    let classes = [];
    if (this.localExpectedAnswer != obj.answer) {
      classes.push("btn-turned-off");
    } else {
      classes.push(`btn-${obj.type}`);
    }

    return classes;
  }

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
</script>

<style lang="scss" scoped>
.btn-group {
  margin-bottom: 2px;
}

.btn {
  padding: 0;
  width: 50px;
  height: 27px;
}

.btn-turned-off {
  color: gray;
  background-color: #f8f9fa;
  border: 0;

  &:hover {
    color: gray;
    background-color: #e2e6ea;
  }
}

.btn-sm:nth-child(2) {
  width: 59px;
}
</style>
